import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-change-step-dialog',
  templateUrl: './change-step-dialog.component.html',
  styleUrl: './change-step-dialog.component.scss'
})
export class ChangeStepDialogComponent implements OnInit, OnChanges {

  @Input() showDialog: boolean = false;
  @Input() application: any;
  @Output() closeOpenErrorDialog = new EventEmitter<boolean>();
  
  stepChangeErrorDialogVisible: boolean = false;
  
  constructor() {}

  ngOnInit(): void {
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.showDialog) {
      const showDialogValue = changes.showDialog.currentValue;
      
      if (showDialogValue === true) {
        this.stepChangeErrorDialogVisible = true;
      }
      else if (showDialogValue === false) {
        this.stepChangeErrorDialogVisible = false;
      }
    }
  }
  
  closeDialog(): void {
    this.stepChangeErrorDialogVisible = false;
    this.closeOpenErrorDialog.emit(false);
    window.location.reload();
  }
  
  onVisibleChange(visible: boolean): void {
    if (!visible) {
      this.closeOpenErrorDialog.emit(false);
    }
  }
}
